// extracted by mini-css-extract-plugin
export default {"productListContainer":"homeProductsList_productListContainer__f55a0"};